import { ALERT_ADD_MESSAGE, ALERT_CLEAR } from './action';

const initialState = null;

const reducer = (state = initialState, action) => {
    
  switch (action.type) {
    case ALERT_CLEAR:
    case ALERT_ADD_MESSAGE:
        return action.payload;
    default: {
      return state;
    }
  }
};

export default reducer;
